import { createApi } from "@reduxjs/toolkit/query/react";

import { PasswordMisuseDomainAlert } from "@/pages/browser-defender/demo/passwordMisuseUpdated/service/domain";
import { browserDefenderBaseQuery } from "@/utils/rtkQuery";

type ActionPayload = {
  domain: string;
  phishingAlertIds: number[];
  reuseAlertIds: number[];
  reason?: string;
};

export const passwordMisuseApi = createApi({
  reducerPath: "passwordMisuseApi",
  baseQuery: browserDefenderBaseQuery(),
  tagTypes: ["PasswordMisuse"],
  endpoints: (builder) => ({
    // Query endpoints
    getPhishingAlerts: builder.query<PasswordMisuseDomainAlert[], void>({
      query: () => ({
        url: "/password_misuse_updated/phishing",
        method: "GET",
      }),
      providesTags: ["PasswordMisuse"],
    }),
    getReuseAlerts: builder.query<PasswordMisuseDomainAlert[], void>({
      query: () => ({
        url: "/password_misuse_updated/reuse",
        method: "GET",
      }),
      providesTags: ["PasswordMisuse"],
    }),
    getArchivedAlerts: builder.query<PasswordMisuseDomainAlert[], void>({
      query: () => ({
        url: "/password_misuse_updated/archived",
        method: "GET",
      }),
      providesTags: ["PasswordMisuse"],
    }),

    // Mutation endpoints
    allowDomain: builder.mutation<void, ActionPayload>({
      query: (payload) => ({
        url: "/admin_actions/password_misuse_updated/allow",
        method: "POST",
        body: payload,
      }),
    }),
    reuseDomain: builder.mutation<void, ActionPayload>({
      query: (payload) => ({
        url: "/admin_actions/password_misuse_updated/reuse",
        method: "POST",
        body: payload,
      }),
    }),
    blockDomain: builder.mutation<void, ActionPayload>({
      query: (payload) => ({
        url: "/admin_actions/password_misuse_updated/block",
        method: "POST",
        body: payload,
      }),
    }),
    archiveAlerts: builder.mutation<void, ActionPayload>({
      query: (payload) => ({
        url: "/admin_actions/password_misuse_updated/archive",
        method: "POST",
        body: payload,
      }),
    }),
    unarchiveAlerts: builder.mutation<void, ActionPayload>({
      query: (payload) => ({
        url: "/admin_actions/password_misuse_updated/unarchive",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetPhishingAlertsQuery,
  useGetReuseAlertsQuery,
  useGetArchivedAlertsQuery,
  useAllowDomainMutation,
  useReuseDomainMutation,
  useBlockDomainMutation,
  useArchiveAlertsMutation,
  useUnarchiveAlertsMutation,
} = passwordMisuseApi;
